import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import { SubscriptionRunStatuses } from "constants/reportSubscriptions";
import { formatInOffset } from "helpers/reportSubscriptions";

const useStyles = makeStyles()(() => ({
	row: {
		fontSize: "13px",
		color: "#374151",
	},
	label: {
		fontWeight: 600,
		marginRight: "4px",
	},
	dot: {
		display: "inline-block",
		width: "8px",
		height: "8px",
		borderRadius: "50%",
		marginRight: "5px",
		verticalAlign: "middle",
	},
	success: {
		backgroundColor: "#22c55e",
	},
	failed: {
		backgroundColor: "#ef4444",
	},
	error: {
		fontSize: "12px",
		color: "#b91c1c",
		marginTop: "2px",
	},
}));

const SubscriptionLastRunStatus = ({ subscription }) => {
	const { classes, cx } = useStyles();
	const { t } = useTranslation();
	const { lastRunStatus, lastRunAt, lastRunError, timezone } = subscription;
	if (lastRunStatus === SubscriptionRunStatuses.None || !lastRunStatus) {
		return (
			<Typography className={classes.row}>
				<span className={classes.label}>{t("label.lastRunColon")}</span>
				{t("message.notYetRun")}
			</Typography>
		);
	}
	const failed = lastRunStatus === SubscriptionRunStatuses.Failed;
	const runDate = formatInOffset(lastRunAt, timezone) || t("label.never");
	return (
		<>
			<Typography className={classes.row}>
				<span className={classes.label}>{t("label.lastRunColon")}</span>
				{runDate} —{" "}
				<span
					className={cx(classes.dot, failed ? classes.failed : classes.success)}
				/>
				{failed ? t("label.failed") : t("label.success")}
			</Typography>
			{failed && lastRunError ? (
				<Typography className={classes.error}>
					{t("message.errorColon", { error: lastRunError })}
				</Typography>
			) : null}
		</>
	);
};

export default SubscriptionLastRunStatus;
